// The following is the list of setting names. These need to be unique.
export const FONT_ADJUSTMENT = "fontAdjustment";
export const LAST_READ_HISTORY = "lastReadHistory";
export const FAVORITE_WORKS = "favoriteWorks";
export const COOKIE_ACCEPTED = "cookieAccepted";
